import React from "react";
import { Modal, BlockStack, Text, Button, Divider, Badge } from "@shopify/polaris";
import { useBranch } from "../../context/BranchContext";

function BranchSwitcherModal({ open, onClose }) {
  const { branches, branch, setBranch } = useBranch();

  const lpBranches = branches.filter((b) => b.segment === "largo_plazo");
  const cpBranches = branches.filter((b) => b.segment === "corto_plazo");

  const handleSelect = (b) => {
    setBranch(b);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title="Cambiar Sucursal">
      <Modal.Section>
        <BlockStack gap="300">
          {lpBranches.map((b) => (
            <Button
              key={b.id}
              fullWidth
              variant={branch?.id === b.id ? "primary" : "secondary"}
              onClick={() => handleSelect(b)}
            >
              {b.name} {branch?.id === b.id && <Badge tone="info">Actual</Badge>}
            </Button>
          ))}

          <Divider />
          <Text variant="headingSm" tone="subdued">Corto Plazo</Text>

          {cpBranches.map((b) => (
            <Button
              key={b.id}
              fullWidth
              variant={branch?.id === b.id ? "primary" : "secondary"}
              onClick={() => handleSelect(b)}
            >
              {b.name} {branch?.id === b.id && <Badge tone="info">Actual</Badge>}
            </Button>
          ))}
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}

export default BranchSwitcherModal;
